import React from "react";
import Footer from "../../components/footer";
import PersonalDetails from "../../components/PersonalDetails";
import EmailAddress from "../../components/EmailAddress";
import ProfilePhoneNumber from "../../components/ProfilePhoneNumber";
import MailingAddress from "../../components/MailingAddress";
import EmergencyContact from "../../components/EmergencyContact";
import { useUserProfile } from "../../hooks/getUserProfile";

const AdminUserDetails = () => {
  const { data: userProfile, isLoading, error, refetch } = useUserProfile();
  return (
    <>
      <div className="container-fluid pt-12 pl-21 pb-12 pr-24 h-100 noScroll">
        <div className="card border-0 h-100">
          <div className="card-body mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="font-weight-lighter mb-0">User's Profile</h5>
              <label className="small-text decoration-0">
                POMMe ID: <span className="ml-1">1234</span>
              </label>
            </div>
            <hr />

            <div className="noScroll h-90 px-35">
              <div className="noScroll h-90 verticalScroll pb-17">
                <PersonalDetails
                  userProfile={userProfile?.data}
                  isLoading={isLoading}
                  refetch={refetch}
                />
                <EmailAddress
                  userProfile={userProfile?.data}
                  isLoading={isLoading}
                  refetch={refetch}
                />
                <ProfilePhoneNumber
                  userProfile={userProfile?.data}
                  isLoading={isLoading}
                  refetch={refetch}
                />
                <MailingAddress
                  userProfile={userProfile?.data}
                  isLoading={isLoading}
                  refetch={refetch}
                />
                <EmergencyContact
                  userProfile={userProfile?.data}
                  isLoading={isLoading}
                  refetch={refetch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminUserDetails;
